import React from "react";
import './style.css';
import '../../img/cart.svg';
import { Loading } from "../Loading/Loading";

type HeaderProps = {
    countInCart: number;
    isLoaded: boolean;
};

export function Header(props: HeaderProps){
    return(
        <header className='header'>
            <div className='wrapper'>
                <h1 className='heading'>Online Store</h1>
                <Loading isLoaded = {props.isLoaded} />
                <div className="cart">
                    <span className="cart-counter">{`${props.countInCart}`}</span>
                    <img className="cart-image" src="./img/cart.svg" alt=""></img>
                </div>
            </div>
        </header>
    );
}
